import { useFormikContext } from "formik";

import { AddressesStepContent } from "./AddressesStepContent";
import { VehicleStepContent } from "./VehicleStepContent";
import { SubventionStepContent } from "./SubventionStepContent";

import Box from "../../../components/layout/Box";
import { FormValues } from "../../Form";
import ProgressBar from "../../../components/molecules/ProgressBar";
import Image from "../../../components/primitives/Image"
import logo from "../../../images/logo-full.png";

import { useState, useEffect } from 'react';

export enum Steps {
  Addresses = "Votre trajet",
  Vehicle = "Votre véhicule",
  Subventions = "Forfait Mobilité Durable",
}

const Components = {
  Addresses: AddressesStepContent,
  Vehicle: VehicleStepContent,
  Subventions: SubventionStepContent,
} as const;


// Custom hook to get window width
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run effect only once

  return width;
}


const FormContent = () => {

  const windowWidth = useWindowWidth();
  // Example condition based on window width
  const shouldDisplayComponent = windowWidth > 1200; // Example threshold
  
  const { values } = useFormikContext<FormValues>();

  const isAddressesStepCompleted =
    values.addresses.home.label.length > 0 &&
    values.addresses.work.label.length > 0 &&
    values.addresses.weekly_comutes > 0 &&
    values.addresses.submitted;

  const isVehicleTypeStepCompleted =
    isAddressesStepCompleted &&
    values.vehicle.type !== "unknown" &&
    values.vehicle.submitted;
  // const isVehicleTypeStepCompleted = true

  const findStep = (): keyof typeof Steps => {
    if (isVehicleTypeStepCompleted) {
      return "Subventions";
    }
    if (isAddressesStepCompleted) {
      return "Vehicle";
    }
    return "Addresses";
  };

  const step = findStep();

  const StepComponent = Components[step];
  const steps = Object.entries(Steps).map(([, value]) => value);

  return (
    <>
      
      <Box flexRatio={1} flex col all="m" mw="750px" >
        <ProgressBar steps={steps} activeStep={Steps[step]} />
        <StepComponent />
      </Box>

      {
        
          shouldDisplayComponent ? (
            <Box flexRatio={1} flex col all="m" mw="750px">
              <Box flex col flexRatio={1} justifyContent="center" alignItems="center">
                <Image src={`/vues/${step}.png`} alt="Logo" width="80%" />
                <img src={logo} alt="Logo" width="50%" />
              </Box>
            </Box>
          ) : <div style={{ display: "none" }}></div>
        
      }
      
      
    </>
  );
};

export { FormContent };
